import React from 'react';
import { Box } from '@mui/material';
import { alpha } from '@mui/material/styles';

type PulseDotProps = {
  color: string;
  size?: number;
};

export default function PulseDot({ color, size = 20 }: PulseDotProps) {
  // Snap aux pixels entiers pour éviter les demi-pixels
  const s = Math.round(size);
  // Taille du cœur forcée à un entier pair pour un rendu net
  const coreSize = Math.max(4, (Math.round(s * 0.4) >> 1) << 1);

  return (
    <Box
      aria-label="status-indicator"
      sx={{
        position: 'relative',
        display: 'grid',
        placeItems: 'center',
        width: s,
        height: s,
        flexShrink: 0,
        boxSizing: 'border-box',
      }}
    >
      {/* Ring = exactement la taille du conteneur */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          borderRadius: '50%',
          border: `2px solid ${alpha(color, 0.3)}`,
          pointerEvents: 'none',
          boxSizing: 'border-box',
        }}
      />

      {/* Core centré via grid (sans transform) */}
      <Box
        sx={{
          width: coreSize,
          height: coreSize,
          borderRadius: '50%',
          backgroundColor: color,
          boxShadow: `0 0 ${Math.round(s * 0.3)}px ${alpha(color, 0.3)}`,
          pointerEvents: 'none',
        }}
      />
    </Box>
  );
}
